export default __webpack_public_path__ + "static/media/slide-1.022197a0.webp";